export default {"src":"/_next/static/media/shaved-cat.2cd0ded3.svg","height":222,"width":499};